import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { homeFor, useAuth } from "../../context/AuthContext";
import { Role } from "../../types";

export function FullScreenLoader() {
    return (
        <div className="min-h-screen bg-[#020617] flex items-center justify-center">
            <Loader2 className="text-[#8b5cf6] animate-spin" size={40} />
        </div>
    );
}

/** Requires login (and optionally one of `roles`). Renders child routes via <Outlet />. */
export default function ProtectedRoute({ roles }: { roles?: Role[] }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <FullScreenLoader />;

    if (!user) {
        return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />;
    }

    if (roles && !roles.includes(user.role)) {
        return <Navigate to={homeFor(user.role)} replace />;
    }

    return <Outlet />;
}

/** Login page: already logged in -> go to the role's home page */
export function PublicOnlyRoute({ children }: { children: React.ReactElement }) {
    const { user, loading } = useAuth();

    if (loading) return <FullScreenLoader />;
    if (user) return <Navigate to={homeFor(user.role)} replace />;

    return children;
}